export default {
    CREATE_ORDER: "CREATE_ORDER",
    GET_ORDER: "GET_ORDER",
    GET_ORDER_DETAIL: "GET_ORDER_DETAIL",
    GET_ORDER_QRCODE: "GET_ORDER_QRCODE",
    CHANGE_PAGE_NUMBER: 'order/CHANGE_PAGE_NUMBER',
    CHANGE_PAGE_SIZE: 'order/CHANGE_PAGE_SIZE'
}